import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

type ListOption = { id: string; name: string };

type Props = {
  card: { id: string; title: string } | null;
  mainLists: ListOption[];
  busy: boolean;
  targetListId: string;
  onTargetChange: (id: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
};

const RestoreCardModal = ({ card, mainLists, busy, targetListId, onTargetChange, onCancel, onConfirm }: Props) => (
  <Modal isOpen={!!card} toggle={() => !busy && onCancel()}>
    <ModalHeader toggle={() => !busy && onCancel()}>Restore card</ModalHeader>
    <ModalBody>
      <p className="mb-3">
        Move <strong>{card?.title}</strong> back to a list on the main board.
      </p>
      <FormGroup>
        <Label for="restore-list">List</Label>
        {mainLists.length === 0 ? (
          <p className="text-warning small mb-0">No lists available on the main board.</p>
        ) : (
          <Input
            id="restore-list"
            type="select"
            value={targetListId}
            onChange={(e) => onTargetChange(e.target.value)}
            disabled={busy}
          >
            {mainLists.map((list) => (
              <option key={list.id} value={list.id}>
                {list.name}
              </option>
            ))}
          </Input>
        )}
      </FormGroup>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" outline onClick={onCancel} disabled={busy}>
        Cancel
      </Button>
      <Button color="primary" onClick={onConfirm} disabled={busy || !targetListId || mainLists.length === 0}>
        Restore
      </Button>
    </ModalFooter>
  </Modal>
);

export default RestoreCardModal;
